import Page from "components/layout/Page";
import { getAccessTokenInCookie } from 'hooks/util/makeCookie';
import { useEffect } from 'react';
import ReactGA from "react-ga4";

const Elem: React.FC<any> = ({ children }) => {
  const handle404Error = () => {
    const refresh = localStorage.getItem('token');

    let authObj: { [key: string]: string } = {};
    const access = getAccessTokenInCookie();

    if (!refresh && !access) {
      window.location.href="/onboarding/0/start";
    } else if (!refresh && access) {
      window.location.href="/home"
      // window.location.href = "/onboarding/0/start"
    } else if (refresh && !access) {
      localStorage.removeItem("token");
      window.location.href ="/onboarding/0/start"
    } else if (refresh && access) {
      window.location.href="/home"
    } 
    // else {
    //   window.location.href="/home"
    // }
  };

  useEffect(()=> {
    const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
    if (gaId) {
      ReactGA.send({ hitType: "pageview", page:"/404", title: "404 error" })
    }
    handle404Error()
  },[])

  return (
    <div>
      <Page disable={false}>
      </Page>
    </div>
  );
};

export default Elem;